const GoogleMapKey = process.env.REACT_APP_GOOGLEMAP_KEY;

export default GoogleMapKey;
